import { SITE_HG } from '@/config';
import { isBRServer } from '@/utils/Validators/validation';

const REGISTER_DOMAIN_URL_BY_BRAND = {
  br: `${SITE_HG}/registro-de-dominio`,
  es: `${SITE_HG}/dominios`,
};

const SUPPORT_DOMAINS_URL_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/categories/115000074153',
  es: 'https://soporte.hostgator.mx/hc/es-419/categories/28437884275987',
};

const SUPPORT_SECURITY_URL_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/sections/360007329973-SiteLock',
  es: '',
};

const SUPPORT_HOST_AND_SERVERS_URL_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/categories/115000074014',
  es: 'https://soporte.hostgator.mx/hc/es-419/categories/28437884383123',
};

const TRANSFER_DOMAIN_REQUIREMENTS_URL_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115001894134',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/217312747--C%C3%B3mo-transferir-un-dominio-a-HostGator-',
};

const TRANSFER_DOMAIN_TO_HG_URL_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115001894134',
  es: `${SITE_HG}/dominios`,
};

const TRANSFER_ES_DOMAIN_URL_BY_BRAND = {
  cl: `${SITE_HG}/transferir-dominios`,
  es: `${SITE_HG}/transferir-dominios`,
};

const DNS_WIZARD_HELP_URL_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000497973#Opcao1',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/217236957#opcion-1',
};

const DNS_WIZARD_PROPAGATION_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000451693',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360024988331',
};

const DNS_WIZARD_HOW_TO_VERIFY_PROPAGATION_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000451693#verificar',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360024988331#propagado',
};

const DNS_WIZARD_HOW_TO_CONFIG_ALTER_PLATFORM_SITE = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000497973#Opcao1',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/217236957#opcion-1',
};

const DNS_WIZARD_EMAIL_HELP_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360041621714',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/115001162711',
};

const DNS_WIZARD_EMAIL_HOW_CONFIGURE_MAIL_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360002631274',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/216721368',
};

const EPP_KEY_HOW_TO_ORDER_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000389394#solicitar',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360038889171',
};

const HOW_TO_TRANSFER_A_DOMAIN_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115001894134-Como-transferir-um-dom%C3%ADnio-para-a-HostGator-',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/217312747-C%C3%B3mo-transferir-la-administraci%C3%B3n-de-un-dominio-a-HostGator',
};

const HOW_TO_CREATE_OR_ALTER_DNS_REGISTER_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000389554-Como-criar-ou-alterar-um-registro-A-MX-TXT-CNAME-e-outros-na-Zona-DNS',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/217312747-C%C3%B3mo-transferir-la-administraci%C3%B3n-de-un-dominio-a-HostGator',
};

export const REGISTER_DOMAIN_URL = REGISTER_DOMAIN_URL_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_DOMAINS_URL = SUPPORT_DOMAINS_URL_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_HOST_AND_SERVERS_URL = SUPPORT_HOST_AND_SERVERS_URL_BY_BRAND[isBRServer ? 'br' : 'es'];
export const TRANSFER_DOMAIN_REQUIREMENTS_URL = TRANSFER_DOMAIN_REQUIREMENTS_URL_BY_BRAND[isBRServer ? 'br' : 'es'];
export const TRANSFER_DOMAIN_TO_HG_URL = TRANSFER_DOMAIN_TO_HG_URL_BY_BRAND[isBRServer ? 'br' : 'es'];
export const TRANSFER_ES_DOMAIN_URL = TRANSFER_ES_DOMAIN_URL_BY_BRAND[isBRServer ? 'br' : 'es'];

export const SUPPORT_SECURITY_URL = SUPPORT_SECURITY_URL_BY_BRAND[isBRServer ? 'br' : 'es'];
export const DNS_WIZARD_HELP_URL = DNS_WIZARD_HELP_URL_BY_BRAND[isBRServer ? 'br' : 'es'];
export const DNS_WIZARD_PROPAGATION = DNS_WIZARD_PROPAGATION_BY_BRAND[isBRServer ? 'br' : 'es'];
export const DNS_WIZARD_HOW_TO_VERIFY_PROPAGATION = DNS_WIZARD_HOW_TO_VERIFY_PROPAGATION_BY_BRAND[isBRServer ? 'br' : 'es'];
export const DNS_WIZARD_HOW_TO_CONFIG_ALTER_PLATFORM = DNS_WIZARD_HOW_TO_CONFIG_ALTER_PLATFORM_SITE[isBRServer ? 'br' : 'es'];
export const DNS_WIZARD_EMAIL_HELP = DNS_WIZARD_EMAIL_HELP_BY_BRAND[isBRServer ? 'br' : 'es'];
export const DNS_WIZARD_EMAIL_HOW_CONFIGURE_MAIL = DNS_WIZARD_EMAIL_HOW_CONFIGURE_MAIL_BY_BRAND[isBRServer ? 'br' : 'es'];
export const EPP_KEY_HOW_TO_ORDER = EPP_KEY_HOW_TO_ORDER_BY_BRAND[isBRServer ? 'br' : 'es'];
export const HOW_TO_TRANSFER_A_DOMAIN = HOW_TO_TRANSFER_A_DOMAIN_BY_BRAND[isBRServer ? 'br' : 'es'];
export const HOW_TO_CREATE_OR_ALTER_DNS_REGISTER = HOW_TO_CREATE_OR_ALTER_DNS_REGISTER_BY_BRAND[isBRServer ? 'br' : 'es'];
